import angular from 'angular';
import { routes } from "./calendarizacao.routes";
import CalendarizacaoElevadoresController from "./calendar.controller";
export default angular.module('app.elv.calendarizacao', [])
    .config(routes)
    .controller('CalendarizacaoElevadoresController', CalendarizacaoElevadoresController)
    .name;
